import { FETCH_HOLIDAYS_REQUEST, FETCH_HOLIDAYS_SUCCESS, FETCH_HOLIDAYS_FAILURE } from './actionTypes';
import { fetchHolidays as fetchHolidaysApi } from '../../services/fetch';

export const fetchHolidays = (year) => async (dispatch, getState) => {
  const { holidaysReducer } = getState();

  if (holidaysReducer.holidaysByYear[year] || holidaysReducer.fetchingYears[year]) {
    return;
  }

  dispatch({ type: FETCH_HOLIDAYS_REQUEST, payload: { year } });

  try {
    const holidays = await fetchHolidaysApi(year);
    dispatch({
      type: FETCH_HOLIDAYS_SUCCESS,
      payload: { year, holidays },
    });
  } catch (error) {
    console.error(`Failed to fetch holidays for ${year}:`, error);
    dispatch({
      type: FETCH_HOLIDAYS_FAILURE,
      payload: { year, error: error.message },
    });
  }
};

export const fetchHolidaysForRange = (startDate, endDate) => (dispatch) => {
  const startYear = new Date(startDate).getFullYear();
  const endYear = new Date(endDate).getFullYear();
  for (let year = startYear; year <= endYear; year++) {
    dispatch(fetchHolidays(year));
  }
};
